(() => {
  const quantityLimit = 9;
  const contactUrl = '/pages/contact';

  const getQuantity = (form) => {
    const input = form.querySelector('[name="quantity"]');
    const value = Number.parseInt(input?.value, 10);
    return Number.isFinite(value) && value > 0 ? value : 1;
  };

  const updateForm = (form) => {
    const quantity = getQuantity(form);
    const requiresQuote = quantity > quantityLimit;
    const addToCart = form.querySelector('.product-info__add-button');
    const dynamicCheckout = form.querySelector('.product-info__dynamic-checkout-button');
    let contactPricing = form.querySelector('.js-quantity-pricing-contact');

    if (!contactPricing) {
      contactPricing = document.createElement('div');
      contactPricing.className = 'js-quantity-pricing-contact mt-4';
      contactPricing.innerHTML =
        '<p class="mb-3 text-start">For quantities of 10 or more, please contact us for pricing.</p>' +
        '<a class="btn btn--secondary w-full" href="' + contactUrl + '">Contact us for pricing</a>';

      const insertAfter = dynamicCheckout || addToCart;
      if (insertAfter) {
        insertAfter.insertAdjacentElement('afterend', contactPricing);
      } else {
        form.appendChild(contactPricing);
      }
    }

    if (addToCart) addToCart.hidden = requiresQuote;
    if (dynamicCheckout) dynamicCheckout.hidden = requiresQuote;
    contactPricing.hidden = !requiresQuote;
  };

  const initialiseForm = (form) => {
    if (form.dataset.quantityPricingContactReady === 'true') {
      updateForm(form);
      return;
    }

    form.dataset.quantityPricingContactReady = 'true';
    const update = () => updateForm(form);

    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('click', () => window.setTimeout(update, 0));
    form.addEventListener('submit', (event) => {
      if (getQuantity(form) > quantityLimit) {
        event.preventDefault();
        update();
      }
    });

    update();
  };

  const initialise = (scope = document) => {
    if (scope.matches?.('form.js-product-form')) initialiseForm(scope);
    scope.querySelectorAll?.('form.js-product-form').forEach(initialiseForm);
  };

  document.addEventListener('DOMContentLoaded', () => initialise());
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();